import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import { connect } from "react-redux";

import PropTypes from "prop-types";
import genericAction from "@Actions/generic";

// Components
import FilterMaster from "@Components/FilterMaster";
import { dropdownFormat } from "@Utils/formats";

// Lodash
import { isEmpty, map, concat, split, find, sortBy } from "lodash";

// staticData
import {
	contactOption,
	orderByOptions,
	orderByOptionsDetailed,
	etiquetasColumns,
	etiquetasGrupoColumns,
	anioMesColumns,
	noTrabajadasColumns,
	actionsColumns,
	chatTagsColumns,
	chatTagsDetailedColumns,
} from "./staticData";

// Styles
import styles from "./styles.module.css";

const FilterModal = ({
	dispatch,
	setPlatformfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	options,
	setSeletedFilteres,
	seletedFilteres,
	dateField,
	setDateField,
	onApplyFilters,
	channelFilters,
	setChannelFilters,
	channels,
	setTabValue,
	stateValue,
	setStateValue,
	conditionValue,
	setConditionValue,
	orderBy,
	setOrderBy,
	orderDirection,
	setOrderDirection,
	actionsSelected = [],
	categoriesSelected = [],
	setCategoriesSelected = () => {},
	groupBy,
	setGroupBy,
	section,
	setSection,
	// Render props
	showTable = false,
	children = null,
	onEditFilters = null,
	onCancelFilters = null,
}) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState("");
	const [tagsData, setTagsData] = useState("");
	const [categoriesData, setCategoriesData] = useState([]);
	const [cleaned, setCleaned] = useState(false);
	const [filtersByReportType, setFiltersByReportType] = useState({});
	const [selectedFilterTemp, setSelectedFilterTemp] = useState(seletedFilteres);
	const [tempOrderBy, setTempOrderBy] = useState(orderBy || "");
	const [tempOrderDirection, setTempOrderDirection] = useState(orderDirection || "");
	const [actionsHistory, setActionsHistory] = useState(actionsSelected);
	const [triggerFilter, setTriggerFilter] = useState(0);

	const onRemoveActiveFilter = (removerCallback) => {
		removerCallback();
		setTriggerFilter((prev) => {
			return prev + 1;
		});
	};

	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	const orderDirectionOptions = (find(orderByOptions, { key: "orderDirection" }) || {}).options || [];

	useEffect(() => {
		(async () => {
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const categoriesPromise = dispatch(genericAction({ method: "get", route: "category/all" }));
			const [usersResponse, tagsResponse, groupResponse, categoriesResponse] = await Promise.all([
				usersPromise,
				tagsPromise,
				groupPromise,
				categoriesPromise,
			]);
			const platoformsMapped = sortBy(
				map(channels, (item) => {
					return {
						key: item.id,
						text: `${item.platform.name} - ${item.label.toLowerCase()}`,
						value: item.id,
					};
				}),
				(item) => {
					return (item.text || "").toLowerCase();
				}
			);

			const groupsMapped = sortBy(dropdownFormat(groupResponse, "name", "id"), (item) => {
				return (item.text || "").toLowerCase();
			});
			const agentsMapped = sortBy(dropdownFormat(usersResponse, "user.fullName", "userId"), (item) => {
				return (item.text || "").toLowerCase();
			});
			const tagsMapped = sortBy(dropdownFormat(tagsResponse, "name", "id"), (item) => {
				return (item.text || "").toLowerCase();
			});
			const categoriesMapped = sortBy(dropdownFormat(categoriesResponse, "name", "id"), (item) => {
				return (item.text || "").toLowerCase();
			});
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });
			setGroupsData(groupsMapped);

			setChannelfiltersData(platoformsMapped);
			setAgentsData(agentsMapped);
			setTagsData(tagsMapped);
			setCategoriesData(categoriesMapped);
		})();
	}, []);

	const checkAll = (name) => {
		switch (name) {
			case "channelFilters":
				if (!channelAll) {
					const allChannelIds = map(channels, (item) => {
						return item.id;
					});
					setChannelFilters(allChannelIds);
					setChannelAll(true);
				} else {
					setChannelFilters([]);
					setChannelAll(false);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const allGroupIds = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(allGroupIds);
					setGroupsAll(true);
				} else {
					setGroupsfilters([]);
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		if (!section) {
			errorsTest.selected = "Debe seleccionar una sección";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(selectedFilterTemp)) {
			errorsTest.selected = "Debe seleccionar un tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (section !== "Generales" && isEmpty(conditionValue)) {
			errorsTest.selected = "La Modalidad es un campo requerido.";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(startDate) && isEmpty(endDate)) {
			errorsTest.selected = "Desde/Hasta es requerido";
			setErrors(errorsTest);
			return;
		}

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp) &&
			isEmpty(actionsHistory);

		const onlyReportType =
			!isEmpty(selectedFilterTemp) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(actionsHistory);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		if (onlyReportType) {
			errorsTest.selected =
				"Seleccione al menos otro campo además del tipo de reporte (por ejemplo, debe llenar una fecha en el Rango de Fechas).";
			setErrors(errorsTest);
			return;
		}

		if (tempOrderBy && !tempOrderDirection) {
			errorsTest.selected = "Si selecciona 'Ordenar por', también debe seleccionar 'Ascendente' o 'Descendente'.";
			setErrors(errorsTest);
			return;
		}

		if (
			selectedFilterTemp === "Acciones" &&
			isEmpty(actionsHistory) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(channelFilters) &&
			isEmpty(startDate) &&
			isEmpty(endDate)
		) {
			// If actions is empty, we still allow filter if other fields are present,
			// but we follow the general rule of 'at least one field'.
		}

		if (selectedFilterTemp === "Año/Mes") {
			const currentMonth = Moment().format("YYYY-MM");
			if (!startDate) {
				errorsTest.selected = "Debe seleccionar el mes de inicio ('Desde')";
				setErrors(errorsTest);
				return;
			}
			if (!endDate) {
				if (startDate === currentMonth) {
					setEndDate(startDate);
				} else {
					errorsTest.selected = "Debe seleccionar el mes final ('Hasta')";
					setErrors(errorsTest);
					return;
				}
			}
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) {
			filters["chat.userId[]"] = concat([], agents);
		}
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["chat.groupId&*"] = 0;
			} else {
				filters["chat.groupId[]"] = concat([], groupsfilters);
			}
		}

		if (!isEmpty(tagsSelected)) filters["tagId[]"] = tagsSelected;
		if (!isEmpty(categoriesSelected)) filters["categoryId[]"] = categoriesSelected;
		if (note) filters["chat.text"] = note;
		if (!isEmpty(channelFilters)) {
			filters["chat.channelId[]"] = concat([], channelFilters);
		}
		if (selectedFilterTemp === "Acciones" && !isEmpty(actionsHistory)) {
			filters["action[]?"] = actionsHistory;
		}

		if (selectedFilterTemp === "Año/Mes") {
			const key = "date";
			const start = startDate ? startDate.slice(0, 7) : "";
			const end = endDate ? endDate.slice(0, 7) : start;
			filters[key] = `${start},${end}`;
		} else if (dateField && (startDate || endDate)) {
			const start = startDate || "";
			const end = endDate || "";
			let currentDateField = dateField;

			if (selectedFilterTemp === "Detalladas") {
				if (conditionValue.length === 1 && conditionValue[0] === "abiertas") {
					filters.includeClosed = false;
					currentDateField = "createdDate";
				} else if (conditionValue.length === 1 && conditionValue[0] === "cerradas") {
					filters.includeClosed = true;
					currentDateField = "closeDate";
				}
			}

			filters[currentDateField] = `${start},${end}`;
		}
		if (tempOrderBy) {
			filters.orderKey = tempOrderBy;
			if (setOrderBy) setOrderBy(tempOrderBy);
		}
		if (tempOrderDirection) {
			filters.orderDir = tempOrderDirection;
			if (setOrderDirection) setOrderDirection(tempOrderDirection);
		}

		if (selectedFilterTemp === "Resumidas") {
			if (stateValue) filters.state = stateValue;
			if (!isEmpty(conditionValue)) filters["status[]"] = conditionValue;
		}

		if (groupBy) {
			filters.groupBy = groupBy;
		}

		setFiltersByReportType((prev) => {
			return {
				...prev,
				[selectedFilterTemp]: filters,
			};
		});

		if (onApplyFilters) {
			setSeletedFilteres(selectedFilterTemp);
			onApplyFilters(filters);
		}
		// onClose(); // No longer a modal
	};

	useEffect(() => {
		const filters = filtersByReportType[selectedFilterTemp];
		if (filters) {
			setAgents(filters["chat.userId[]"] || filters.userId || []);
			setContacts(filters.contactId ? { id: filters.contactId } : {});
			setGroupsfilters(filters["chat.groupId[]"] || filters.groups || []);
			setTagsSelected(filters["tagId[]"] || filters.tags || []);
			setCategoriesSelected(filters["categoryId[]"] || filters.categories || []);
			setNote(filters["chat.text"] || filters.text || "");
			setChannelFilters(filters["chat.channelId[]"] || []);
			setPlatformfilters(filters.platforms || []);

			if (filters.createdDate || filters.closeDate || filters["chat.closeDate"]) {
				const range = filters.createdDate || filters.closeDate || filters["chat.closeDate"];
				const [start, end] = split(range, ",");
				setStartDate(start);
				setEndDate(end);
				setDateField(filters.createdDate ? "createdDate" : "closeDate");
			}
			if (setGroupBy) setGroupBy(filters.groupBy || "");
			// Seccion se mantiene independiente del tipo de reporte
		}
	}, [selectedFilterTemp]);

	useEffect(() => {
		if (triggerFilter > 0) {
			onFilter();
		}
	}, [triggerFilter]);

	const onChangeDropdown = (value, name) => {
		if (name === "channelFilters") {
			setChannelFilters(value);
			if (channelfiltersData.length === value.length) {
				setChannelAll(true);
			} else {
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};
	const onContactsRemove = () => {
		setContacts({});
	};
	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setPlatformfilters([]);
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setCategoriesSelected([]);
		setStartDate("");
		setEndDate("");
		setNote("");
		setActionsHistory([]);
		setGroupsAll(false);
		setChannelAll(false);
		setErrors({ platformfilters: "", selected: "" });
		setSeletedFilteres("Etiquetas");
		setSelectedFilterTemp("Etiquetas");
		if (setGroupBy) setGroupBy("");
		if (setSection) setSection("");
		setCleaned(true);

		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};

	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
		setTempOrderBy("");
		setTempOrderDirection("");
		setTagsSelected([]);
		setCategoriesSelected([]);
		setNote("");
		if (typeof setTabValue === "function") setTabValue("");
		if (typeof setStateValue === "function") setStateValue("");

		if (value === "Año/Mes") {
			const todayMonth = Moment().format("YYYY-MM");
			setStartDate(todayMonth);
			setEndDate(todayMonth);
		} else {
			const today = Moment().format("YYYY-MM-DD");
			setStartDate(today);
			setEndDate(today);
		}
	};

	const getFieldsetClass = (filters, data) => {
		const safeFilters = filters || [];
		const safeData = data || [];
		if (isEmpty(safeFilters) && isEmpty(agents) && isEmpty(tagsSelected)) return "";

		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;

		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;

		return styles.hasOptions;
	};
	const getMaxDate = () => {
		return selectedFilterTemp === "Año/Mes" ? Moment().format("YYYY-MM") : Moment().format("YYYY-MM-DD");
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
		if (value === "createdDate" || value === "closeDate") {
			setDateField(value);
		}
	};

	const getOrderByOptions = () => {
		if (selectedFilterTemp === "Etiquetas")
			return map(etiquetasColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Etiquetas Grupo")
			return map(etiquetasGrupoColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "No Trabajadas")
			return map(noTrabajadasColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Año/Mes")
			return map(anioMesColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Acciones")
			return map(actionsColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Resumen Notas")
			return map(chatTagsColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Detalle Notas")
			return map(chatTagsDetailedColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		return map(orderByOptionsDetailed, (col) => {
			return { key: col.key, text: col.text, value: col.value };
		});
	};

	return (
		<div className={styles.container}>
			<FilterMaster
				errors={errors}
				options={options}
				selectedFilterTemp={selectedFilterTemp}
				onChangeSelection={onChangeSelection}
				startDate={startDate}
				endDate={endDate}
				handleInput={handleInput}
				getMaxDate={getMaxDate}
				tempOrderBy={tempOrderBy}
				handleOrderByChange={handleOrderByChange}
				getOrderByOptions={getOrderByOptions}
				orderDirectionOptions={orderDirectionOptions}
				tempOrderDirection={tempOrderDirection}
				setTempOrderDirection={setTempOrderDirection}
				contacts={contacts}
				onContactsSelect={onContactsSelect}
				onContactsRemove={onContactsRemove}
				contactOption={contactOption}
				agents={agents}
				setAgents={setAgents}
				agentsData={agentsData}
				renderLabelPlatforms={renderLabelPlatforms}
				tagsSelected={tagsSelected}
				handleInputDropdown={handleInputDropdown}
				tagsData={tagsData}
				handleTipyfication={handleTipyfication}
				note={note}
				setNote={setNote}
				channelAll={channelAll}
				checkAll={checkAll}
				channelFilters={channelFilters}
				channelfiltersData={channelfiltersData}
				renderLabelChannels={renderLabelChannels}
				groupsData={groupsData}
				groupsAll={groupsAll}
				groupsfilters={groupsfilters}
				onChangeDropdown={onChangeDropdown}
				renderLabelDepartments={renderLabelDepartments}
				cleanModal={cleanModal}
				cleaned={cleaned}
				getFieldsetClass={getFieldsetClass}
				stateValue={stateValue}
				setStateValue={setStateValue}
				conditionValue={conditionValue}
				setConditionValue={setConditionValue}
				actionsHistory={actionsHistory}
				setActionsHistory={setActionsHistory}
				onRemoveActiveFilter={onRemoveActiveFilter}
				groupBy={groupBy}
				setGroupBy={setGroupBy}
				section={section}
				setSection={setSection}
				showTable={showTable}
				onApplyFilters={onFilter}
				onEditFilters={onEditFilters}
				onCancelFilters={onCancelFilters}
				categoriesSelected={categoriesSelected}
				categoriesData={categoriesData}
				handleCategoriesChange={setCategoriesSelected}>
				{children}
			</FilterMaster>
		</div>
	);
};

FilterModal.propTypes = {
	dispatch: PropTypes.func,
	setPlatformfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	categoriesSelected: PropTypes.array,
	setCategoriesSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	options: PropTypes.array,
	setSeletedFilteres: PropTypes.func,
	seletedFilteres: PropTypes.array,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channelFilters: PropTypes.string,
	setChannelFilters: PropTypes.func,
	channels: PropTypes.array,
	stateValue: PropTypes.string,
	setStateValue: PropTypes.func,
	conditionValue: PropTypes.array,
	setConditionValue: PropTypes.func,
	groupBy: PropTypes.string,
	setGroupBy: PropTypes.func,
	section: PropTypes.string,
	setSection: PropTypes.func,
	orderBy: PropTypes.string,
	setOrderBy: PropTypes.func,
	orderDirection: PropTypes.string,
	setOrderDirection: PropTypes.func,
	setTabValue: PropTypes.func,
	actionsSelected: PropTypes.array,
	showTable: PropTypes.bool,
	children: PropTypes.node,
	onEditFilters: PropTypes.func,
	onCancelFilters: PropTypes.func,
};

function mapStateToProps({ chats, company, user }) {
	return {
		reply: chats.reply,
		channels: company.channels,
		user,
	};
}

export default connect(mapStateToProps)(FilterModal);
